import { type CommonProps, ONBOARDING_EVENTS, trackEvent } from "."

export const name = {
  landOn: (props: CommonProps) => trackEvent(ONBOARDING_EVENTS.CHOOSE_YOUR_NAME_LAND, props),
  edit: (props: CommonProps) => trackEvent(ONBOARDING_EVENTS.CHOOSE_YOUR_NAME_GO_EDIT, props),
  submit: (props: CommonProps) => trackEvent(ONBOARDING_EVENTS.CHOOSE_YOUR_NAME_SUBMIT, props),
}
